module.exports = __webpack_public_path__ + "static/img/remark-link.4558ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/remark-link.png
// module id = ZY5R
// module chunks = 1